import React, { useEffect, useMemo, useState } from "react";

const DISPLAY_DURATION = 3000;

const shuffleMembers = (members) => {
    const shuffledMembers = [...members];

    for (let index = shuffledMembers.length - 1; index > 0; index -= 1) {
        const randomIndex = Math.floor(Math.random() * (index + 1));
        [shuffledMembers[index], shuffledMembers[randomIndex]] = [shuffledMembers[randomIndex], shuffledMembers[index]];
    }

    return shuffledMembers;
};

const maskMemberName = (memberName) => {
    const nameCharacters = Array.from((memberName || "").trim());

    if (nameCharacters.length === 0) return "";
    if (nameCharacters.includes("*")) return nameCharacters.join("");
    if (nameCharacters.length === 1) return "*";
    if (nameCharacters.length === 2) return `${nameCharacters[0]}*`;

    return `${nameCharacters[0]}${"*".repeat(nameCharacters.length - 2)}${nameCharacters[nameCharacters.length - 1]}`;
};

function ExamPlanCompletionBoard({ members, mmbrSeq, isVisible }) {
    const completedMemberNames = useMemo(() => {
        if (!Array.isArray(members)) return [];

        // const completedMembers = members.filter((member) => member?.MMBR_NAME && member?.MIS_COMPLETE_YN === "Y");
        const completedMembers = members.filter((member) => member?.MMBR_NAME);
        const currentMember = completedMembers.find((member) => member.MMBR_SEQ === mmbrSeq);
        const shuffledMembers = shuffleMembers(completedMembers.filter((member) => member.MMBR_SEQ !== mmbrSeq));

        return [
            ...(currentMember ? [currentMember.MMBR_NAME.trim()] : []),
            ...shuffledMembers.map((member) => maskMemberName(member.MMBR_NAME)),
        ].filter(Boolean);
    }, [members, mmbrSeq]);

    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        setCurrentIndex(0);
    }, [completedMemberNames]);

    useEffect(() => {
        if (!isVisible || completedMemberNames.length < 2) return undefined;

        let timeoutId = null;
        const scheduleNextMember = () => {
            if (typeof document !== "undefined" && document.hidden) return;
            timeoutId = setTimeout(() => {
                setCurrentIndex((index) => (index + 1) % completedMemberNames.length);
            }, DISPLAY_DURATION);
        };
        const handleVisibilityChange = () => {
            if (timeoutId !== null) {
                clearTimeout(timeoutId);
                timeoutId = null;
            }
            scheduleNextMember();
        };

        scheduleNextMember();
        document.addEventListener("visibilitychange", handleVisibilityChange);

        return () => {
            if (timeoutId !== null) clearTimeout(timeoutId);
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, [completedMemberNames.length, currentIndex, isVisible]);

    if (!isVisible || completedMemberNames.length === 0) return <div className="expln__board" />;

    const nextIndex = (currentIndex + 1) % completedMemberNames.length;

    return (
        <div className="expln__board">
            <span className="expln__board-icon" />
            <div className="expln__board-window">
                <div
                    key={`${currentIndex}-${completedMemberNames[currentIndex]}`}
                    className={`expln__board-track ${completedMemberNames.length > 1 ? "is-moving" : ""}`}
                >
                    <span className="expln__board-msg">{completedMemberNames[currentIndex]} 학생 미션 완료</span>
                    {completedMemberNames.length > 1 && (
                        <span className="expln__board-msg">{completedMemberNames[nextIndex]} 학생 미션 완료</span>
                    )}
                </div>
            </div>
        </div>
    );
}

export default React.memo(ExamPlanCompletionBoard);
